import {combineActions, handleActions} from 'redux-actions'
import {DEFAULT_SORTING} from './constants'
import * as ActionTypes from './actionTypes'
import * as LightBoxActionTypes from './components/lightbox/actionTypes'
import {arrayToMap, filterMapByKeys} from '../../../js/atUtils'


const createICalFeedsReducer = ({
    ICALENDAR = null,
}) => {
    const initialState = {
        activeTab: null,
        allFeeds: [],
        sharedFeeds: [],
        loading: false,
        allSorting: DEFAULT_SORTING,
        sharedSorting: DEFAULT_SORTING,
        recentlyConfiguredFeedId: null,
        userActionLoading: false,
        feedsContentLoading: false,
        ...ICALENDAR.ICAL_INFO,
    }

    return handleActions({
        [ActionTypes.ACTIVE_TAB_SET]: (state, {payload: activeTab}) => ({...state, activeTab}),
        [ActionTypes.ALL_FEEDS_LIST_SET]: (state, {payload: allFeeds}) => ({...state, allFeeds: arrayToMap(allFeeds)}),
        [ActionTypes.SHARED_FEEDS_LIST_SET]: (state, {payload: sharedFeeds}) => ({...state, sharedFeeds: arrayToMap(sharedFeeds)}),
        [ActionTypes.DELETE_FEED_DATA_LOAD_SUCCESS]: (state, {payload: feedId}) => {
            return {
                ...state,
                allFeeds: filterMapByKeys(state.allFeeds, [feedId], feed => feed.id),
                sharedFeeds: filterMapByKeys(state.sharedFeeds, [feedId], feed => feed.id),
            }
        },
        [ActionTypes.LOADING_SET]: (state, {payload: loading}) => ({...state, loading}),
        [ActionTypes.ALL_SORTING_SET]: (state, {payload: allSorting}) => ({...state, allSorting}),
        [ActionTypes.SHARED_SORTING_SET]: (state, {payload: sharedSorting}) => ({...state, sharedSorting}),
        [ActionTypes.FEED_ADD]: (state, {payload: feed}) => ({
            ...state,
            allFeeds: {
                ...state.allFeeds,
                [feed.id]: feed,
            },
        }),
        [ActionTypes.RECENTLY_CONFIGURED_FEED_ID_SET]: (state, {payload: recentlyConfiguredFeedId}) => ({...state, recentlyConfiguredFeedId}),
        [ActionTypes.FEEDS_CONTENT_LOADING_SET]: (state, {payload: feedsContentLoading}) => ({...state, feedsContentLoading}),
        [combineActions(ActionTypes.ALL_FEEDS_LIST_SET,
            ActionTypes.FEED_REMOVE,
            ActionTypes.ALL_SORTING_SET,
            LightBoxActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD,
            LightBoxActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD,
            LightBoxActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD,
            ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS,
            ActionTypes.ACTIVE_TAB_SET,
        )]: (state) => ({...state, recentlyConfiguredFeedId: null}),
        [combineActions(LightBoxActionTypes.CREATE_FEED_LOAD_DATA,
            LightBoxActionTypes.EDIT_FEED_LOAD_DATA,
            LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA,
            ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD,
            ActionTypes.DELETE_FEED_DATA_LOAD,
        )]: (state) => ({...state, userActionLoading: true}),
        [combineActions(LightBoxActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS,
            LightBoxActionTypes.CREATE_FEED_LOAD_DATA_FAILURE,
            LightBoxActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS,
            LightBoxActionTypes.EDIT_FEED_LOAD_DATA_FAILURE,
            LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS,
            LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE,
            ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS,
            ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_FAILURE,
            ActionTypes.DELETE_FEED_DATA_LOAD_SUCCESS,
            ActionTypes.DELETE_FEED_DATA_LOAD_FAILURE,
        )]: (state) => ({...state, userActionLoading: false}),
        [combineActions(LightBoxActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS,
            LightBoxActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS,
            ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS,
        )]: (state, {payload: feed}) => ({
            ...state,
            allFeeds: {
                ...state.allFeeds,
                [feed.id]: feed,
            },
        }),
    }, initialState)
}

export default createICalFeedsReducer



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/reducer.js